/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 247);
/******/ })
/************************************************************************/
/******/ ({

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Initialize all sub-modules
 */
jQuery(function($) {
	var helper = __webpack_require__(3);

	var modules = {
		reference: __webpack_require__(248),
	};

	// params is supposed to be defined in the page.
	helper.initPage({
		modules: modules
	});
});





/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

var _rohs = __webpack_require__(249);
var _soc = __webpack_require__(251);


/**
 * Module for technical reference on product page
 */
module.exports = {

  /**
   * initlization
   */
  init: function(params) {
    var self = this;

    self.$el = $('.References');

    $.extend(self, params);

    _rohs.init(self);

    _soc.init(self);
  }
};


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

window.Popup = __webpack_require__(98);

/**
 * Module for RoHS certificate on product page
 */
module.exports = {

	/**
	 * initlization
	 */
	init: function(techRef) {
		var self = this;

		$.extend(self, techRef);

		var popup = new Popup({
			$container: $('.RoSH', techRef.$el),
			bodySelector: '#rohsCertificate',
			linkSelector: '.rohs-certificate-link',
			bodyCls: 'rohs-cert-dialog',
			printBtnSelector: '.rohsCertPrint',
			printDivId: 'rohsCertificateDiv'
		});

		self._initRoshPrintButton(popup);
	},

	_initRoshPrintButton: function(popup) {
		var $btn = $('.rohsCertPrint', popup.$body);

		$btn.addClass('btn btn-default btn-print');
	}
};


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

var _helper = __webpack_require__(3);
var Constants = __webpack_require__(8);

/**
 * Boostrap modal template utility 
 */
module.exports = {

	_$tpl: function(cfg) {
		return $('.rs-modal-template', cfg.$container);		
	},

	_setBody: function($tpl, cfg) {
		var $body = $('.modal-body', $tpl);
		if(cfg.bodyUrl) {
			$body.load(cfg.bodyUrl, cfg.loadFn);
		}else{
			$body.append(cfg.$body.toggle(true));
		}
	},

	_show: function(cfg) {
		var self = this, 
			$tpl = self._$tpl(cfg);

		$('.modal-title', $tpl).empty().append(cfg.title);
		self._setBody($tpl, cfg);

		$tpl.on('show.bs.modal', cfg.show);
		$tpl.on('shown.bs.modal', cfg.shown);
		$tpl.on('hide.bs.modal', cfg.hide);

		$tpl.modal('show', $tpl);
	},

	show: function(cfg) {
		var self = this, 
			$tpl = self._$tpl(cfg);

		if($tpl.length === 0) {
		    var $c = $('<div class="modal-container">').appendTo(cfg.$container);
			$c.load(_helper.buildUrl(Constants.modalTemplateUrl), function() {
				self._show(cfg);
			});
		}

		$tpl.modal('show', $tpl);
	}
};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

window.Popup = __webpack_require__(98);
/**
 * Module for Statement of Conformity of the technical reference on product page
 */
module.exports = {

	/**
	 * initlization
	 */
	init: function(techRef) {
		new Popup({
			$container: $('.statementOfConformity', techRef.$el),
			bodySelector: '#statementOfConformity',
			linkSelector: '.statementOfConformity-link',
			bodyCls: 'soc-dialog',
			printBtnSelector: '.btn-print',
			printDivId: 'statementOfConformity'
		});
	}
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

var Constants = __webpack_require__(8);

/**
 * Helper methods 
 */
module.exports = {

	/**
	 * Ajax post method 
	 */
	ajaxPost: function(serviceUri, data, caller, params) {

		var cfg = {
			url: serviceUri,
			dataType: 'json',
			data:  JSON.stringify(data),
			contentType: 'application/json; charset=utf-8',
			cache: false,
			beforeSend: function() {
				if(caller && caller.beforeAjax) caller.beforeAjax();
			}
		};

		$.extend(cfg, params);

		return $.post(cfg)
			.fail(function() {
				console.info('calling ' + serviceUri + ' failed.');
			})
			.always(function() {
				if(caller && caller.afterAjax) caller.afterAjax();
			});
	},

	/**
	 * detect IE browser
	 */
	isIE: function() {
		var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		if (isNaN(msie)) {
			msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);
		}
		return !isNaN(msie);
	},

	/**
	 * initialize every page
	 */
	initPage: function(conf) {		

		var self = this;

		if(typeof params === 'undefined') params = {};

		$.extend(params, Constants);
		$.extend(params, conf);

		$.extend(self, {
			ctxPath: params.ctxPath
		});

		var modules = params.modules;

		for(var key in modules) {
			var module = modules[key];
			if($.isFunction(module.init)) {
				module.init(params);
			}
		}
	},

	on: function(evtName, handler) {
		$(document).on(evtName, handler);
	},

	trigger: function(evtName, args) {
		$(document).trigger(evtName, args);
	},

	printDiv: function(windowId, w, h, fn) {// function to print the DIV element.
	    var DocumentContainer = document.getElementById(windowId);
	    var top = ($(window).height() - h)/2;
	    var left = ($(window).width() - w)/2; 
	    var WindowObject = window.open("", "PrintWindow",
	    			"width=" + w + ",height=" + w + ", top=" + top + ",left=" + left + ", toolbars=no,scrollbars=yes,status=no,resizable=yes");
	    WindowObject.document.writeln(DocumentContainer.innerHTML);

	    WindowObject.onload = function() {
	    	if(fn) {
		    	fn(WindowObject);
	    	}

	    	setTimeout(function() {
	    		WindowObject.print();
	    		WindowObject.close();
	    	}, 300);
		};

		WindowObject.document.close();
	    WindowObject.focus();
	},
	
	/**
	 * formats a product number.
	 * E.g. 202-467 -> 0202467
	 */
	formatPN: function(pn) {
		pn = pn.replace('-', '');

		while( 7 - pn.length > 0) {
			pn = '0' + pn;
		}

		return pn;
	},

	redirect: function(url) {
		this.getWindow().location.href = url; 
	},

	/**
	 * for mock purpose
	 */
	getWindow: function() {
		return window;
	},
	
	buildUrl: function(uri) {
		var self = this;

		return self.ctxPath + uri;
	},	

	/**
	* Calls `callback` once when `jQueryEl` is scrolled into view
	*/
	onVisibleOnce: function (jQueryEl, callback) {
		if (jQueryEl.length === 0) {
			return;
		}

		var self = this;
	    var scrollHandler = function () {
	        if (self.isCurrentlyVisible(jQueryEl)) {
	            $(document).off('scroll', scrollHandler);
	            callback();
	        }
	    }
	    $(document).scroll(scrollHandler);
	},

	/**
	* Returns `true` if `jQueryEl` is fully displayed within the viewport
	*/
	isCurrentlyVisible: function(jQueryEl) {
	    var boundingClientRect = jQueryEl[0].getBoundingClientRect();
	    var elTop = boundingClientRect.top;
	    var elBottom = boundingClientRect.bottom;

	    return (elTop >= 0) && (elBottom <= window.innerHeight);
	}
};


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/*
 * Constants 
 */
module.exports = {
  maxQuantity: 999999,

  qtyChangeEvt: 'rs.product.qty.changed',

  hlBreakPriceChangeEvt: 'rs.product.hl.price.changed',

  cartAddedEvt: 'rs.cart.added',

  popupShowEvt: 'rs.product.popup.show',

  popupShownEvt: 'rs.product.popup.shown',

  popupHideEvt: 'rs.product.popup.hide',

  qtyPlaceHolder: '##QTY##',

  modalTemplateUrl: '/modalTpl.jsp',

  addToCartUrl: '/services/shoppingBasket/lineItems/{articleId}/{quantity}',

  checkStockLevelUrl: '/services/product/getstock/{articleId}/{productId}/{quantity}',

  basketUrl: (typeof(params) !== "undefined") ? params.basketUrl : null,

  getPartsListUrl: '/services/product/partslist',

  savePartsListUrl: '/services/product/partslist/{partsListName}/{articleId}/{quantity}'
};


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

var _commonsHelper = __webpack_require__(3);
var _modalTpl = __webpack_require__(250);

var Constants = __webpack_require__(8);

/**
 * Base module for pop-ups on product page
 */
module.exports = function(cfg) {
	var self = this;

	$.extend(self, cfg);

	var _initPrintButton = function() {
		var $btn = $(self.printBtnSelector, self.$body);

		// Remove the origin onclick handler
		$btn.removeAttr('onclick');

		$btn.off('click').on('click', _print);
	};

	var _print = function() {
		_commonsHelper.printDiv(self.printDivId, 800, 400, _updatePopupStyle);
	};

	var _updatePopupStyle = function(popup) {
		var mainCss = $('link[href*="main.css"]').clone().prop('outerHTML');
		var productPageCss = $('link[href*="product.min.css"]').clone().prop('outerHTML');
		var bootstrapCss = $('link[href*="custom-bootstrap.min.css"]').clone().prop('outerHTML');

		popup.document.getElementsByTagName('head')[0].innerHTML = mainCss + bootstrapCss + productPageCss;
		var style = popup.document.body.style;
		style.minWidth = 0;
		style.width = '740px';
	};

	var _init = function() {	
		var $a = $(self.linkSelector, self.$container);

		$a.off('click').on('click', _openModal);

		_initPrintButton();
	};

	var _openModal = function() {

		_modalTpl.show({
			$container: self.$container,
			title: self.title,
			$body: self.$body,
			show: _show,
			shown: _shown,
			hide: _hide
		});
	};
	
	var _triggerEvt = function(evtName, e) {
		_commonsHelper.trigger(evtName + self.linkSelector, e);
	}

	var _hide = function(e) {
		_triggerEvt(Constants.popupHideEvt, e);
	};

	var _show = function(e) {
		var $dlg = $(e.relatedTarget), 
			dlgCls = self.bodyCls;

		$('.modal-dialog', $dlg).removeClass(dlgCls).addClass(dlgCls);
		$('.modal-footer', $dlg).remove();

		_triggerEvt(Constants.popupShowEvt, e);
	};

	var _shown = function(e) {
		if($.isFunction(cfg.shown)) {
			cfg.shown();
		}

		_triggerEvt(Constants.popupShownEvt, e);
	};

	if(!self.$body) {
		self.$body = $(self.bodySelector).detach();
	}

	_init();
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// productLibrary.min.js